<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="imgUrl" />
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/" v-if="isAdmin">
            <el-dropdown-item> 首页 </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided v-if="isAdmin">
            <span @click="updateUser" style="display: block">修改</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <el-dialog
      title="修改用户详细"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :width="width1"
    >
      <el-form
        :model="UserInfo"
        :label-width="width2"
        ref="UserForm"
        size="small"
      >
        <el-form-item label="用户名：">
          {{ UserInfo.username }}
        </el-form-item>
        <el-form-item
          label="上传头像："
        >
          <el-upload
            class="upload"
            ref="uploadImage"
            action="#"
            :multiple="false"
            :file-list="uploadFileList"
            :auto-upload="false"
            :headers="headers"
            :limit="limitUpload2">
            <el-button slot="trigger" size="small" type="primary">选取头像</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="头像：" prop="picture" v-if="dialogVisible1">
          <el-image :src="dialogImageUrl" :preview-src-list="[dialogImageUrl]"
                    style="padding-top:5px;width: 28px;height:25px">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </el-form-item>

        <el-form-item label="密码：">
          <el-input
            clearable
            :style='width3'
            placeholder="选填，不填则不修改密码"
            type="password"
            v-model="UserInfo.password"
          ></el-input>
        </el-form-item>
      </el-form>
      <span class="dialog-footer" slot="footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button @click="handleDialogConfirm()" size="small" type="primary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo,updateAdmin } from '@/api/admin'
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import {isMobile} from "@/utils/support";
// import { updatePicture } from "@/api/store";
import {getToken} from "@/utils/auth";

const defaultAdmin = {
  id: null,
  username: null,
  icon: null,
  password: null,
  roles: "",
};
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },
  data() {
    return {
      img: "",
      dialogImageUrl: "",
      companyList: [],
      dialogVisible: false,
      dialogVisible1: false,
      UserInfo: Object.assign({}, defaultAdmin),
      width1:null,
      width2:null,
      width3:null,
      isAdmin:false,
      UserPassword:{},
      uploadFileList: [],
      headers: {"Content-Type": "multipart/form-data;charset=UTF-8"},
      limitUpload2: 1,
      baseUrl:process.env.BASE_API,
      imgUrl:null,
    };
  },

  mounted() {
    if (isMobile()){
      this.width1 = '95%';
      this.width2 = '130px';
      this.width3 = 'width: 75%';
    }else{
      this.width1 = '40%';
      this.width2 = '150px';
      this.width3 = 'width: 60%';
    };
  },

  created() {
    getInfo().then((response) => {
      if (response.data != null) {
        this.UserInfo = response.data;
        this.UserInfo.password = null;
        if(this.UserInfo.icon != null && this.UserInfo.icon != '' && typeof this.UserInfo.icon != 'undefined'){
          this.imgUrl = this.baseUrl + this.UserInfo.icon;
        }else {
          this.imgUrl = null;
        }
      }
      if(this.UserInfo.roles == "客户"){
        this.isAdmin = false;
      }else{
        this.isAdmin = true;
      }
    });
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    updateUser() {
      this.dialogVisible = true;
      getInfo().then((response) => {
        if (response.data != null) {
          this.UserInfo = response.data;
          this.UserInfo.password = null;
          if(this.UserInfo.icon != null && this.UserInfo.icon != '' && typeof this.UserInfo.icon != 'undefined'){
            this.imgUrl = this.baseUrl + this.UserInfo.icon;
          }else {
            this.imgUrl = null;
          }
        }
        if(this.UserInfo.icon != null && this.UserInfo.icon != '' && typeof this.UserInfo.icon != 'undefined'){
          this.constUrl = process.env.BASE_API + '/store/download?type=icon&id=' + encodeURI(this.UserInfo.id);
          image(this.constUrl, (data) =>{
            if(data != null && data != ''){
              this.dialogImageUrl = data;
              this.dialogVisible1 = true;
            }else {
              this.dialogImageUrl = '';
              this.dialogVisible1 = false;
            }
          });
          function image(constUrl, callback) {
            var xhr = new XMLHttpRequest();
            xhr.open("get", constUrl, true);
            xhr.responseType = "blob";
            xhr.setRequestHeader("Authorization", getToken());
            xhr.onload = function () {
              if(xhr.status==200){
                let blob = new Blob([this.response], { type: 'application/octet-stream' });
                var url = window.URL.createObjectURL(blob);
                callback(url);
              }
              if(xhr.status==500){
                url = '';
                callback(url);
              }
            }
            xhr.send();
          }
        }
      });
    },

    handleDialogConfirm() {
      this.$refs["UserForm"].validate((valid) => {
        this.$confirm("是否要确认?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          updateAdmin(this.UserInfo.id, this.UserInfo).then((response) => {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.dialogVisible = false;
            if(typeof this.$refs.uploadImage.uploadFiles[0] != 'undefined'){
              let formData = new FormData(); //声明一个FormDate对象
              formData.append("file", this.$refs.uploadImage.uploadFiles[0].raw);    //把文件信息放入对象中
              formData.append("id", this.UserInfo.id);
              formData.append("type", "icon");
              // updatePicture(formData).then(res => {
              //   if (res.data) {
              //     this.$message.success("上传成功");
              //     getInfo().then((response) => {
              //       if (response.data != null) {
              //         this.UserInfo = response.data;
              //         this.UserInfo.password = null;
              //         if(this.UserInfo.icon != null && this.UserInfo.icon != '' && typeof this.UserInfo.icon != 'undefined'){
              //           this.imgUrl = this.baseUrl + this.UserInfo.icon;
              //         }else {
              //           this.imgUrl = null;
              //         }
              //       }
              //     });
              //   } else {
              //     this.$message.error(res.Message);
              //   }
              // }).catch(err => {
              //   this.$message.error("系统解析失败");
              // });
            }
          });
        });
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue